const round = n => Math.round(n * 10000) / 10000;
export function withMaterialReceipts(orders, receptions) {
  const quantities = new Map();
  const accepted = new Set(receptions.filter(r => r.accepted_for_production).map(r => r.material_key));
  for (const reception of receptions) for (const line of reception.lines || []) {
    quantities.set(line.material_order_id, round((quantities.get(line.material_order_id) || 0) + Number(line.quantity)));
  }
  return orders.map(order => ({ ...order, received_quantity: quantities.get(order.id) || 0, accepted_for_production: accepted.has(order.material_key) }));
}
export const materialStateClasses = label => label === 'Recibido'
  ? 'border-green-300 bg-green-100/70 text-green-900 hover:bg-green-100 hover:text-green-950'
  : label === 'Pendiente de recepción' ? 'border-blue-300 bg-blue-100/70 text-blue-900 hover:bg-blue-100 hover:text-blue-950'
  : label === 'Pendiente de visto bueno' ? 'border-orange-300 bg-orange-100/70 text-orange-900 hover:bg-orange-100 hover:text-orange-950'
  : label === 'Pedido' ? 'border-yellow-300 bg-yellow-100/70 text-yellow-900 hover:bg-yellow-100 hover:text-yellow-950'
  : label === 'Confirmado' ? 'border-orange-300 bg-orange-100/70 text-orange-900 hover:bg-orange-100 hover:text-orange-950' : '';

export const materialReviewPending = order => Boolean(order.supplier_confirmed_at && !order.supplier_reviewed_at);
export function materialDisplayState(orders, state) {
  if (orders.some(materialReviewPending)) return 'Pendiente de visto bueno';
  return state === 'Confirmado' ? 'Pendiente de recepción' : state;
}
export function withMaterialReviews(orders, batches) {
  const parents = new Map(batches.map(batch => [batch.id, batch]));
  return orders.map(order => {
    const parent = parents.get(order.supplier_order_id);
    return parent ? { ...order, supplier_confirmed_at: parent.supplier_confirmed_at, supplier_reviewed_at: parent.supplier_reviewed_at } : order;
  });
}
